$(document).ready(function() {

	$('.services-menu a[data-toggle="collapse"]').mouseover(function() {
		$(this).click();
	});

	$('.services-menu a[data-toggle="collapse"]').parent().mouseleave(function() {
		$(this).find('a[data-toggle="collapse"]').click();
	});

	$('.services-menu li.panel').mouseout(function() {
		$(this).click();
	});

	//

	$('.contacts-side__chat img').on('click', function() {
		$('.contacts-side__chat').toggleClass('open');
	})

	$('.side-phones').on('click', function() {
		$(this).toggleClass('open');
	})

	// services animation

	// $('.hp-cats__box_serv').hover(
	// 	function() {
	// 		$('.services-menu').addClass('show');
	// 	},
	// 	function() {
	// 		$('.services-menu').removeClass('show');
	// 	}
	// )

})